// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"6a67aa04","239":"8e889764","455":"ed83b15a","488":"a3fd23b6","493":"29b69f55","768":"270b5670","809":"05c1d531","947":"f5e8558c","977":"752723df"}[chunkId] + ".chunk.js";
};